import { ITranslationEntry } from '../lang';

export const FI: ITranslationEntry = {
  translations: {
    notifications: 'Ilmoitukset',
    markAllAsRead: 'Merkkaa luetuksi',
    poweredBy: 'Ilmoitukset mahdollistaa',
    settings: 'Asetukset',
  },
  lang: 'fi',
};
